import { GetterTree } from 'vuex';

import { ITabViewState, TAB_VIEW_GETTERS } from './tab-view-types.store';

export const getters: GetterTree<ITabViewState, any> = {
    [TAB_VIEW_GETTERS.GET_TAB_VIEWS]: (state: ITabViewState) => state.tabViews,
    [TAB_VIEW_GETTERS.ACTIVE_TAB_PATH]: (state: ITabViewState) => state.activeTab && state.activeTab.url,
    [TAB_VIEW_GETTERS.ACTIVE_TAB]: (state: ITabViewState) => state.activeTab || null,
    [TAB_VIEW_GETTERS.OLD_TAB]: (state: ITabViewState) => state.oldTab || null
}